
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      staff: null,
      noStaffMember: false,
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.getStaff();
    });
  },
  methods: {
    getStaff () {
      if (this.$route.query.ref) {
        const staffId = this.$route.query.ref;
        this.getStaffById(staffId);
      } else {
        this.noStaffMember = true;
      }
    },
    async getStaffById (id) {
      const params = {
        include: `staffType,images,sponsors.images`,
      };
      const response = await this.$getStats(`staff/${id}`, params);
      if (response !== null) {
        if (response.data) {
          this.staff = response.data;
        } else {
          this.noStaffMember = true;
        }
      }
    },
  },
};
